import { Patterns } from "@omni/schemas/input/patterns";
import { BonusCardType } from "@omni/types/enums/bonusCardType.enum";
import * as LocalStorage from "@omni/utils/localStorage.utils";

import { Config } from "@/utils/config.utils";
import { add, isAfter } from "@/utils/date";
import { StorageKeys } from "@/utils/enums";

type BonusCardState = {
    email: string;
    timeStamp: string;
};

type BonusCardStates = Array<BonusCardState>;

export const setBonusCardRequestedStates = (newState: BonusCardStates) => {
    LocalStorage.setItem(
        StorageKeys.BonusCardRequested,
        JSON.stringify(newState)
    );
};

export const getBonusCardRequestedStates = (): BonusCardStates | undefined => {
    const item = LocalStorage.getItem(StorageKeys.BonusCardRequested);

    if (!item) {
        return undefined;
    }

    let parsedItem;

    try {
        parsedItem = JSON.parse(item);
    } catch {
        parsedItem = undefined;
    }

    if (!parsedItem) {
        return undefined;
    }

    return parsedItem as BonusCardStates;
};

export const hasLocalStorageTimestamp = (email: string) => {
    const state = getBonusCardRequestedStates();
    if (!state) {
        return false;
    }

    const stateForEmail = state.find((s) => s.email === email);

    if (!stateForEmail) {
        return false;
    }

    const dateTimestamp = new Date(parseInt(stateForEmail.timeStamp, 10));

    return isAfter(add(dateTimestamp, { days: 14 }), new Date());
};

export const isType = (
    type: BonusCardType,
    value: string | undefined | null
) => {
    if (!value) return false;

    return Patterns[Config.general.basestore].bonusCard[type]?.test(value);
};
